import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";
import {
    ControlsPosition,
    ProductSliderProps
} from "@omni/types/components/props/productSlider.props";
import { cn } from "@omni/utils/styles";

import { ProductSlider } from "@/components/Product/ProductSlider/productSlider";
import { DeleteFromHistoryButton } from "@/components/Product/ProductSlider/sources/recents/components/deleteFromHistoryButton/deleteFromHistoryButton";
import { DeleteHistoryButton } from "@/components/Product/ProductSlider/sources/recents/components/deleteHistoryButton/deleteHistoryButton";

type Props = ProductSliderProps & {
    className?: string;
};

export const ProductSliderDefault = ({ className, ...props }: Props) => {
    return (
        <ProductSlider
            {...props}
            className={cn(className)}
        >
            <ProductSlider.Header>
                <ProductSlider.Header.Title />
                {props.source === ProductSliderSources.Recent && (
                    <DeleteHistoryButton />
                )}
            </ProductSlider.Header>
            <ProductSlider.Slider
                className={cn("tw:flex", {
                    "tw:flex-col":
                        props.controlsPosition !== ControlsPosition.Default,
                    "tw-flex-row":
                        props.controlsPosition === ControlsPosition.Default
                })}
            >
                {props.controlsPosition === ControlsPosition.Default && (
                    <ProductSlider.Slider.NavButton type={"left"} />
                )}
                <ProductSlider.Slider.Slides>
                    <ProductSlider.Slider.Slides.Slide>
                        <ProductSlider.Slider.Slides.Slide.ProductTile>
                            {props.source === ProductSliderSources.Recent && (
                                <DeleteFromHistoryButton />
                            )}
                        </ProductSlider.Slider.Slides.Slide.ProductTile>
                    </ProductSlider.Slider.Slides.Slide>
                </ProductSlider.Slider.Slides>
                {props.controlsPosition === ControlsPosition.Default && (
                    <ProductSlider.Slider.NavButton type={"right"} />
                )}
                {props.controlsPosition !== ControlsPosition.Default && (
                    <div
                        className={cn("tw:flex tw:mt-4 tw:gap-4", {
                            "tw:self-end":
                                props.controlsPosition ===
                                ControlsPosition.Right,
                            "tw:self-start":
                                props.controlsPosition === ControlsPosition.Left
                        })}
                    >
                        <ProductSlider.Slider.NavButton type={"left"} />
                        <ProductSlider.Slider.NavButton type={"right"} />
                    </div>
                )}
            </ProductSlider.Slider>
        </ProductSlider>
    );
};
